export const VERSION = "Version: 0.0.0";

export const MAX_UPLOAD_SIZE = 1024 * 1024 * 20;

export const SUPPORTED_TYPES = [
    "text/plain",
    "text/javascript",
    "text/x-python",
    "text/html",
    "text/css",
    "text/md",
    "text/csv",
    "text/xml",
    "text/rtf",
    "image/png",
    "image/jpeg",
    "image/webp",
    "image/heic",
    "image/heif",
    "audio/wav",
    "audio/mp3",
    "audio/aiff",
    "audio/aac",
    "audio/ogg",
    "audio/flac",
    "application/pdf",
    "application/x-javascript",
    "application/x-python",
];